const palette = {
  modules: {
    sideMenu:
      'linear-gradient(173.89deg,#181a20 -41.24%,#11141c -4.03%,#11141c 9.89%,#11141c 32.98%,#11141c 54.35%,#11141c 82.94%,#11141c 100.43%,#11141c 110.12%,#11141c 113.54%)',
    sideMenuSecondary:
      'linear-gradient(180deg, #181a20 -16.89%, #11141c 25.29%, #181a20 59.49%, #11141c 100%)',
    sideMenuSecondaryDesktop:
      'linear-gradient(90.15deg,rgba(113,208,244,.1) 1.31%,rgba(113,208,244,0) 104.84%)',
    divider: '#ffffff20',
    readButton: '#339ae6',
    navbar: '#181a20', // Changed from #182634
    appBarItem: '#768da9',
    appBarrActive: '#F0B90B',
    appBar: '#181a20', // Changed from #1f2f46
    input: '#2b3139',
    inputAction: '#364254',
    boxGradient: '#00264e33',
    border: '#ffffff0f',
    checked: '#0ecb81',
    logoColorpending: '#e99831',
    colorChartMarginGreen: '#5BE12C',
    colorChartMarginOrange: '#EA4228',
    colorChartMarginYellow: '#F5CD19',
    colorChartMarginRed: '#FF0000',
    headerModules: '#ffffff0a',
    backgroundIconNotification: '#71d0f41a',
    backgroundHoverNotification:
      'linear-gradient(270.04deg,hsla(0,0%,100%,.08) -1.37%,hsla(0,0%,100%,0) 94.34%)',
    backgroundBadge: '#f50057',
    logoColor: '#ffffff',
    logoColor2: '#ffcd43',
    buttonColor: '#000000',
    headerShadow: 'rgba(240, 185, 11,.301961)',
    tableHead:
      'linear-gradient(187.37deg, rgba(43, 49, 57, 0.4) -30.65%, transparent 220.7%), rgba(43, 49, 57, 0.08)',
    menuIconColor: '#ffffff',
    successModalBg: "#244d41",
    successModalBgBorder: "#5f97876e",
  },

  action: {
    disabledBackground: '',
  },

  divider: 'rgba(250, 250, 250, 0.1)',

  primary: {
    main: '#ffcd43', // Changed from #182634
    dark: '#F0B90B', // Changed from #3f4e63
    light: '#2b3139', // Changed from #253853
    alternate: '#2b3139',
  },

  secondary: {
    main: '#ffcd43', // Changed from #71d0f4
    light: '#4d5763', // Changed from #71d0f41a
    primary: '#181a20', // Changed from #71d0f4
    lightest: '#2b313950', // Changed from #71d0f450
  },

  info: {
    main: '#2b3139',
    secondary: '#2f3e53',
    lightest: '#ffcd4340',
    light: '#939dac',
  },

  text: {
    primary: '#ffffff',
    main: '#ffffff',
    light: '#333333',
    secondary: '#939dac',
    alternate: '#ffcd43',
  },

  background: {
    alert: '#2f3e53',
    main: '#181a20', // Changed from #182634
    default: '#181a20', // Changed from #182634
    paper: '#181a20', // Changed from #182634
    menu: '#29384f',
    headerModal: '#21252d',
    buttonAction: '#ffcd43',
    button: '#ffcd4350',
    disabled: '#364254',
    lightest: '#939dac',
    coinSingle: '#181a20', // Changed from #182634
    boxShadowConvert: '#71d0f400',
    boxShadowPrices: 'rgb(113 208 244 / 20%)',
    convertTrade:
      'linear-gradient(178.98deg,rgba(43, 49, 57,.3) -11.82%,rgba(43, 49, 57,.3) 115.41%)',
    primaryGradient:
      'linear-gradient(180deg,rgba(43, 49, 57,.2),transparent),hsla(0,0%,95.7%,.04)',

    errorGradient:
      'linear-gradient(180deg,rgba(0, 38, 78, 0.2) 0%,rgba(255, 53, 71, 0.1) 100%),rgba(244, 244, 244, 0.04)',

    successGradient:
      'linear-gradient(180deg, #00264e33 0%, #27a17c1a 100%),#f4f4f40a',

    greenGradient:
      'linear-gradient(90deg,rgba(113,208,244,.08) -3.8%,rgba(100,200,222,.08) 49.86%,rgba(83,189,196,.08) 65.61%,rgba(39,161,124,.08) 104.15%)',

    redGradient:
      'linear-gradient(90deg,rgba(113,208,244,.08) -3.8%,rgba(177,138,166,.08) 48.91%,rgba(205,108,132,.08) 73.34%,rgba(255,53,71,.08) 104.15%)',

    blueReverseGradient:
      'linear-gradient(266.48deg,rgba(240, 185, 11,.42) -10.27%,rgba(240, 185, 11,.63) 5.39%,rgba(240, 185, 11,.22) 40.45%,rgba(240, 185, 11,.13) 60.09%,rgba(240, 185, 11,.06) 83.64%,rgba(147,216,242,0) 110.01%)',

    blueBottomToTopGradient:
      'linear-gradient(0deg,rgba(147,216,242,.101961) -7.62%,rgba(147,216,242,0))',
    activeCart:
      'linear-gradient(180deg, rgba(0, 38, 78, 0.2) 0%, rgba(0, 0, 0, 0) 100%), rgba(113, 208, 244, 0.25)',
    blue: 'linear-gradient(177.23deg,#2b3139 -13.49%,#181a20 109.75%)',
    red: 'linear-gradient(177.23deg,#e31818 -13.49%,#940e14 40.43%,#6f0912 70.59%,#390310 109.75%)',
    tabButtonHover: '#F0B90B',
    tabButtonHoverColor: '#000000',
    tradeTypeButton: "#F0B90B",
    tradeTypeButtonActive: "#ffcd43",
    tradeTypeButtonColor: "#000000",
    telegramCard: "#ffffff",
    telegramCardColor: "#333333",
    telegramColor: "#2481cc",
    telegramQrCodeBorderColor: "#4e0b88"
  },

  success: {
    main: '#27a17c',
    primary: '#27a17c',
    light: '#27a17c',
    secondary: '#27a145',
  },

  error: {
    main: '#ff3547',
  },

  warning: {
    main: '#ff9d00',
    secondary: '#ff9d00',
  },

  common: {
    white: '#ffffff',
    black: '#000000',
  },

  grey: {
    30: '#ddd',
    50: '#939dac',
    100: '#717781',
  },
};

export default palette;
